import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputProjectCategoryRelation<T extends EMode = EMode.entity> {
  /** Alias: add */
  add?: number[];
  /** Alias: remove */
  remove?: number[];

  __typename?: string;
}

const fields: FieldDefinitions<InputProjectCategoryRelation> = {
  add: {
    alias: 'add',
  },
  remove: {
    alias: 'remove',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputProjectCategoryRelationEntityDefinition: EntitiyDefinition<InputProjectCategoryRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputProjectCategoryRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
